/**
 * Demo environment
 */
export const environment = {
    production: true,
    URL_API: "https://api.demo.geos2.gesthispania.cloud/payyourfines/",
    URL_API_TINY: "https://api.demo.geos2.gesthispania.cloud/pyf/"
};
